/*****
 * Use this sparingly - we don't need a ton of global state floating around
 * TODO - depending on the state management complexity we may want to invest
 * in redux for state management
 */

import React, { createContext, useContext } from "react";
import { useAuthToken } from "../apis/useAuthToken";
import useIhrApi from "../apis/useIhrApi";

type AuthContextType = ReturnType<typeof useAuthToken> &
    ReturnType<typeof useIhrApi>;

const AuthContext = createContext<AuthContextType | null>(null);

// Provider
export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const auth = useAuthToken();
    const api = useIhrApi(
        auth.saveToken,
        auth.saveEmail,
        auth.saveIsPremium,
        auth.savePremiumFromStripe,
        auth.saveActiveSubscription,
        auth.clearLocalSubscriptionStorage,
    );

    return (
        <AuthContext.Provider value={{ ...auth, ...api }}>
            {children}
        </AuthContext.Provider>
    );
};

/*
    This hook will consume the context - ~~~~DONT~~~ use the old hook anymore
    it will prob only be useful for things that can be memoized and it's not 
    set up to do that
*/
export const useAuthContext = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuthContext must be used within an AuthProvider");
    }
    return context;
};
